import { stickyStackManager } from './stickyStackManager';

document.addEventListener('DOMContentLoaded', () => {
  const headerContainer = document.querySelector('.headerContainer');
  let isNonStickyHeader = true;

  if (!!headerContainer && document.querySelector('meta[name="nonStickyHeader"]').content === 'false') {
    headerContainer.dataset.stickyStackTarget = 'global-header';
    if (!isSmallScreen() && !headerContainer.classList.contains('sticky-top')) {
      headerContainer.classList.add('sticky-top');
    }
    isNonStickyHeader = false;
  }

  registerGlobalStickyLayers();

  //TODO need to remove this code its a custom fix for ticket: https://mcgrawhill.atlassian.net/browse/WECCOE-6277
  // ****************************** STARTS ****************************** \

  if (!isNonStickyHeader) {
    const collapseContainers = document.querySelectorAll('.collapsearea .collapse');

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const collapseElement = mutation.target;
          const isExpanded = collapseElement.classList.contains('show');
          const rect = collapseElement.getBoundingClientRect();
          const isOutOfViewport = rect.bottom > window.innerHeight;
          const isTooCloseToViewport = window.innerHeight - rect.bottom < 100;

          if (isSmallScreen()) {
            return;
          }

          if (isExpanded && (isOutOfViewport || isTooCloseToViewport)) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'instant',
            });
            headerContainer.classList.remove('sticky-top');
          } else {
            headerContainer.classList.add('sticky-top');
          }
        }
      });
    });

    collapseContainers.forEach((collapseContainer) => {
      observer.observe(collapseContainer, { attributes: true, attributeFilter: ['class'] });
    });
    // ****************************** End ******************************
  }
});

function registerGlobalStickyLayers() {
  const candidates = Array.from(
    document.querySelectorAll('.headerContainer, #global-nav, [data-layer-comp="GlobalNav"]')
  );
  const topLevelHeaders = candidates.filter(
    (target) => !candidates.some((otherTarget) => otherTarget !== target && otherTarget.contains(target))
  );

  topLevelHeaders.forEach((header, index) => {
    stickyStackManager.registerLayer(`global-header-${index}`, [header], header);
  });
}

function isSmallScreen() {
  return window.innerWidth < 768;
}
